import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AssetStateProfileResponse, AssetStateProfileCreateRequest, AssetStateProfileUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { AssetStateProfileDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { EventFilterService } from 'app/services/events/event-filter.service';

@RegisterEntityHandler('assetstateprofile')
@Injectable()
export class AssetStateProfileHandler extends EntityHandler<AssetStateProfileResponse> {

    constructor(
        admin: AdminEditorService,
        private filters: EventFilterService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listAssetStateProfiles/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listAssetStateProfiles(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'assetstateprofile',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.ASSETSTATEPROFILES'),
        }));
    }

    getEntity(id: string): Promise<AssetStateProfileResponse> {
        return this.admin.getCached(`getAssetStateProfile/${id}`, api => api.entities.getAssetStateProfile(id), 10);
    }

    createEntity(ownerId: string, entity: AssetStateProfileCreateRequest): Promise<AssetStateProfileResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createAssetStateProfile(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateAssetStateProfile(entity.id, { state: state as any }));
    }

    getGridIcon(item: AssetStateProfileResponse): string {
        return item.items && item.items.length > 1 ? ICONS.assetstateprofile : 'exclamation-triangle';
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ASSETSTATEPROFILE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', this.getGridIcon),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<AssetStateProfileResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new AssetStateProfileDetailsSectionHandler(this.admin, this.filters, ownerId, false),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: AssetStateProfileUpdateRequest, sections: FormSectionHandler<AssetStateProfileResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'assetstateprofile',
            entity: {}, // set up some defaults if you want
            sections: [
                new AssetStateProfileDetailsSectionHandler(this.admin, this.filters, ownerId, true),
            ],
        });
    }

}












